let socket = null;

export const connectWebSocket = (path, onMessageCallback) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Cannot connect to WebSocket: No authentication token");
    return;
  }

  // Close any existing connection
  if (socket && socket.readyState !== WebSocket.CLOSED) {
    socket.close();
  }

  // Create new WebSocket connection
  const wsUrl = `${process.env.VUE_APP_WS_URL}/${path}?token=${token}`;
  socket = new WebSocket(wsUrl);

  socket.onopen = () => {
    console.log("WebSocket connection established");
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      // Handle nested message structure
      if (data.message && typeof data.message === "object") {
        onMessageCallback(data.message);
      } else {
        onMessageCallback(data);
      }
    } catch (error) {
      console.error("Error parsing WebSocket message:", error);
    }
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  socket.onclose = (event) => {
    console.log("WebSocket connection closed:", event.code, event.reason);
  };

  return socket;
};

export const disconnectWebSocket = () => {
  if (socket && socket.readyState !== WebSocket.CLOSED) {
    socket.close();
    socket = null;
  }
};

export const sendWebSocketMessage = (message) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify({ message }));
    return true;
  }
  return false;
};
